export const scrollToBottom = {
    data() {
        return {

        }
    },
    methods: {
        scrollToBottom() {
            let el = () => document.getElementById('scrollToBottom') || false;

            let promise = new Promise((resolve, reject) => {
                let count = 0;

                let checkEl = () => {
                    setTimeout(() => {
                        if (el()) {
                            resolve(el());
                        } else if (count < 6) {
                            count++;
                            checkEl();
                        } else {
                            reject();
                        }
                    }, 50);
                }
                checkEl();
            });

            promise
            .then((el) => {
                el.scrollTop = el.scrollHeight;
            });
        }
    }
}
